export default __webpack_public_path__ + "static/media/Group8867.17909cef.svg";